




























































































  import Vue from 'vue';

  export default Vue.extend({
    props: {
      value: {
        type: Number,
        default: null,
      },
      hideTitle: {
        type: Boolean,
        default: false,
      },
      images: {
        type: Array,
        default: null,
      },
      categories: {
        type: Array,
        required: true,
      },
    },
    data() {
      return {
        categoryId: null,
        searchMode: false,
        imageId: this.value,
        selectedCategoryIds: [],
        query: null,
      };
    },
    computed: {
      categoryName() {
        if (this.categoryId) {
          return this.categories.find(c => c.id == this.categoryId).name;
        }
        return null;
      },
      selectedCategories() {
        if (this.selectedCategoryIds.length) {
          return this.categories.filter(c => this.selectedCategoryIds.includes(c.id));
        }
        return this.categories;
      },
    },
    watch: {
      imageId(val) {
        this.$emit('close');
        this.$emit('input', val);
      },
    },
    methods: {
      imageRefName: id => 'image-' + id,
      isSelectedCategory(id) {
        return this.selectedCategoryIds.includes(id);
      },
      toggleCategory(id) {
        if (this.isSelectedCategory(id)) {
          this.selectedCategoryIds = this.selectedCategoryIds.filter(i => i != id);
        } else {
          this.selectedCategoryIds.push(id);
        }
      },
      iconClick() {
        if (this.categoryId == null) {
          this.$emit('close');
        } else {
          this.categoryId = null;
        }
      },
      imagesInCategory(categoryId) {
        return this.images.filter(i => i.donationImageCategory.id == categoryId);
      },
    },
  });
